import * as React from 'react';

export enum AlertCategoryEnum {
    Danger = 'alert-danger',
    Warning = 'alert-warning',
    Info = 'alert-info',
    Success = 'alert-success'
}

interface AlertProps {
    show: boolean;
    category: AlertCategoryEnum;
    children: any;
    automationid?: string;
}

const Alert = (props: AlertProps) => {
    if (!props.show) return null;

    return (
        <div className={"alert " + props.category} data-automationid={props.automationid} style={{ wordWrap: 'break-word'}}>
            {props.children}
        </div>
    );
}

export default Alert;
